import React from "react";
import { t } from "ttag";

import { GroupDiningFeatureBlock as Value } from "@reactivated";

import { RichTextBlock } from "@thelabnyc/thelabui/src/components/RichText";
import { concatClassNames } from "@thelabnyc/thelabui/src/utils/styles";

import { TYPEKIT_URL } from "../../utils/groups";
import { MenuViewer } from "../MenuViewer";

import groups from "../../styles/groups.module.scss";
import styles from "./index.module.scss";

interface Props {
    value: Value;
}

export const GroupDiningFeatureBlock = (props: Props) => {
    const value = props.value;
    if (!value.heading || !value.body || !value.image) {
        return null;
    }
    const Heading = value.heading_level === "h1" ? "h1" : "h2";
    const showBooking = Boolean(value.booking_heading || value.booking_body);
    const reservationLabel =
        value.reservation_button_text || t`Reserve a Table`;
    return (
        <div className={concatClassNames([groups.tokens, styles.band])}>
            <link rel="stylesheet" href={TYPEKIT_URL} precedence="default" />
            <section
                className={concatClassNames([
                    styles.intro,
                    showBooking ? undefined : styles.introAlone,
                ])}
            >
                <Heading className={groups.scriptHeading}>
                    {value.heading}
                </Heading>
                <img
                    className={styles.photo}
                    src={value.image.url}
                    alt={value.image.default_alt_text}
                    width={value.image.width}
                    height={value.image.height}
                    loading="lazy"
                />
                <RichTextBlock
                    className={concatClassNames([groups.body, styles.body])}
                    value={value.body}
                />
                <div className={styles.ctaRow}>
                    <MenuViewer
                        title={value.menu_title || t`Group Dining Menus`}
                        buttonText={value.menu_button_text || t`View Menus`}
                        buttonClassName={groups.buttonWide}
                        pages={value.menu_pages ?? []}
                        document={value.menu_document ?? null}
                    />
                </div>
            </section>
            {showBooking && (
                <section className={styles.booking}>
                    {value.booking_heading && (
                        <h2 className={styles.eyebrow}>
                            {value.booking_heading}
                        </h2>
                    )}
                    {value.booking_body && (
                        <RichTextBlock
                            className={concatClassNames([
                                groups.body,
                                styles.bookingBody,
                            ])}
                            value={value.booking_body}
                        />
                    )}
                    <div className={styles.bookingCta}>
                        <a
                            className={groups.buttonWide}
                            href={value.reservation_url ?? undefined}
                        >
                            {reservationLabel}
                        </a>
                    </div>
                </section>
            )}
        </div>
    );
};
